import { sendHttpRequest } from "lib/fetcher";

export function getAlertsByStaticParams(queryString) {
  return sendHttpRequest({
    url: "/alert/alerts?withLocation=true&withLicense=true&" + queryString,
    method: "GET",
  });
}
export function getAlertAndEventByGpt(
  text,
  relevanceThreshold = undefined,
  withLocation = true,
  filters: any = {},
  abortController = null,
  version,
) {
  const _modifiedFilter = {
    ...filters,
    startedAt: filters?.startedAt ? +filters?.startedAt : undefined,
    endedAt: filters?.endedAt ? +filters?.endedAt : undefined,
    version: version === "magicV2" ? "image_v1" : undefined,
  };
  if (version === "magicV2") {
    switch (relevanceThreshold) {
      case 0: // more accurate
        relevanceThreshold = 0.5;
        break;
      case -1: // normal
        relevanceThreshold = -0.7;
        break;
      case -2: // more result
        relevanceThreshold = -1;
        break;
    }
  }

  return sendHttpRequest({
    url: "/alert/events/search",
    method: "POST",
    data: {
      text,
      snapshot_req: {
        width: 1024,
      },
      paging: {
        limit: 50,
      },
      threshold: relevanceThreshold,
      withLocation: true,
      ..._modifiedFilter,
      withLicense: true,
    },
    signal: abortController?.signal,
  });
}
